var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209px",
    height: "230px",
    viewBox: "0 0 209 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9668180B-5C25-4063-AC64-B5A1699F241D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7756568,21.5286554 C16.3379504,21.5459608 19.3417802,15.4228471 19.3259104,11.2324232 C19.3099144,7.0419993 15.8990864,3.6320734 11.7075498,3.61608449 C7.51601308,3.60020764 4.13101739,6.98430125 4.14689426,11.1747251 C4.16288315,15.365149 7.21336314,21.5112764 11.7756568,21.5286554 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZERO-SCREEN",
    transform: "translate(-76.000000, -137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(76.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box",
    transform: "translate(0.000000, 88.616680)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#A1ABB6",
    points: "95.1617021 8.52651283e-14 95.1617021 41.9871776 22.9028827 18.1454259"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D5DDE7",
    points: "22.9028827 18.1454259 108.502128 46.5093168 108.502128 143.362817 22.9028827 106.260915"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5D0D9",
    points: "108.502128 46.5093168 180.652374 23.2936096 180.652374 107.588677 108.502128 143.362817"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#C5D0D9",
    points: "22.9028827 18.1454259 108.502128 46.5093168 84.2986327 87.151909 0 54.6596556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#DAE2EC",
    points: "108.502128 46.5093168 180.637281 22.9168591 208.878143 60.0563783 134.890247 89.7136431"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#8E99A3",
    points: "95.1617021 2.27373675e-13 180.637281 22.9168591 108.502128 46.5093168 95.1617021 41.9871776"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trail",
    transform: "translate(75.000000, 34.616680)",
    strokeDasharray: "6,4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95719136,89.6322735 C7.04752129,82.3893297 13.9494891,74.4919563 20.6306087,69.8901034 C27.3117284,65.2882505 44.4296118,59.9138422 48.8880332,72.5842562 C53.3464546,85.2546701 28.1540668,97.6836793 13.306122,85.2546701 C3.40749216,76.9686639 -0.968329868,68.3760875 0.178655917,59.4769408",
    id: "Path-3",
    stroke: "#DCE4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5775046,-1.42108547e-14 C21.4094586,26.6622191 0.441176471,35.308398 5.68434189e-14,59.4769408",
    id: "Path-5",
    stroke: "#849EB8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bee",
    transform: "translate(148.438466, 25.003998) rotate(12.000000) translate(-148.438466, -25.003998) translate(127.438466, 4.503998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-Copy-+-Rectangle-Copy-2-Mask",
    transform: "translate(6.177666, 10.205931)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A0B0BE",
    transform: "translate(11.736402, 12.572370) rotate(46.000000) translate(-11.736402, -12.572370) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EBEFF4",
    mask: "url(#mask-2)",
    transform: "translate(14.165439, 9.558795) rotate(43.000000) translate(-14.165439, -9.558795) ",
    points: "6.12766977 8.18881322 22.1930455 8.24979361 22.2032089 10.9287776 6.13783317 10.8677972"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#EBEFF4",
    mask: "url(#mask-2)",
    transform: "translate(11.258431, 13.754586) rotate(43.000000) translate(-11.258431, -13.754586) ",
    points: "3.22066093 12.3846041 19.2860367 12.4455844 19.2962001 15.1245685 3.23082433 15.0635881"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "#EBEFF4",
    mask: "url(#mask-2)",
    transform: "translate(8.004255, 17.011499) rotate(43.000000) translate(-8.004255, -17.011499) ",
    points: "-0.0318203654 16.0880141 16.0335554 16.1489944 16.040331 17.9349838 -0.0250447667 17.8740034"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#8FA7BE",
    fill: "#8B9AA8",
    cx: 28.9042553,
    cy: 11.6518298,
    rx: 5.78085106,
    ry: 5.825
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5041399,18.9869282 C10.819774,17.2247667 12.3972267,15.3563837 15.236498,13.3817791 C15.201325,12.6392083 14.7881704,12.1074807 13.9970342,11.7865962 C13.2058981,11.4657118 12.8303336,9.74648433 12.8703408,6.62891392 C6.83749008,-1.60976228 2.72690752,-1.60976228 0.53859314,6.62891392 C-2.74387843,18.9869282 10.0306888,21.6301704 10.5041399,18.9869282 Z",
    id: "Path-6",
    fill: "#EBEFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2952474,41.5571343 C34.6139835,39.808166 36.2041904,37.9532754 39.0658683,35.9924625 C39.0307215,35.2555185 38.6146309,34.7279748 37.8175964,34.4098315 C37.020562,34.0916882 36.6428181,32.3856054 36.684365,29.291583 C30.6088305,21.1175865 26.466941,21.1192272 24.2586965,29.2965052 C20.9463297,41.5624222 33.8171433,44.1805866 34.2952474,41.5571343 Z",
    id: "Path-6-Copy",
    fill: "#EBEFF4",
    transform: "translate(31.390173, 32.822115) scale(1, -1) rotate(93.000000) translate(-31.390173, -32.822115) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9422228,5.82682985 C33.427791,5.25796289 33.6705752,4.35856852 33.6705752,3.12864676 C33.6705752,1.89872499 33.2317619,0.855842737 32.3541353,-1.13242749e-13",
    id: "Path-7",
    stroke: "#CAD1E5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4643115,11.6220295 C38.9533526,11.0576561 39.1976298,10.1651567 39.1971431,8.94453121 C39.1966554,7.72390575 38.7540867,6.68873093 37.8694369,5.83900674",
    id: "Path-7-Copy",
    stroke: "#CAD1E5",
    strokeLinecap: "round",
    transform: "translate(38.533290, 8.730518) scale(-1, 1) rotate(-93.000000) translate(-38.533290, -8.730518) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.b561bca1b61ac6537004ef4d238217ce.svg";
export { ForwardRef as ReactComponent };